import React, { useRef, useState } from 'react';

import WindowDialog from 'views/widgets/WindowDialog.jsx';
import SelectionSearchView from "views/widgets/SelectionSearchView.jsx";

export default function ImportFromInstanceDialog(props) {

	let { label, type, url, columns, sort, cancelCallback, okCallback } = props;
	
	const [ selectedState, setSelectedState ] = useState({}); 
	const widthMatches = window.matchMedia("(min-width: 600px)").matches;
	const heightMatches = window.matchMedia("(min-height: 600px)").matches;	
	
	const okBtnClicked = () => {
		let selected = selectionView.current.getSelectedFullObjects();
		if (selected.length == 1) okCallback(selected[0].id, selected[0].name);
		else cancelCallback();
	};
 	
	const getSelectionView = () => {
		return (
			<div className="constituo-dialog-grid-panel">
				<SelectionSearchView
					ref={selectionView}
					className="constituo-selection-view"
					gridClass="constituo-selection-grid-container"
					label={label}
					elemId="selectionView"
					columns={columns}
					sort={sort} 
					type={type}
					url={url}
					additionalUrlParams={"&includeDeleted=false&includeAllInstances=true"}
					selectionMode={"single"}
					selectedState={selectedState}
					setSelectedState={setSelectedState}
				/>
			</div>
		);
	}

	const selectionView = useRef();
	
	const anythingSelected = () => {
		let keys = Object.keys(selectedState);
		keys.filter((key) => selectedState[key]);
		return keys.length > 0;
	};
	
	const getButtons = () => {
		let buttons = [];
		if (anythingSelected()) 
			buttons.push(
	        	<button
	        		key="ok-btn"
	            	className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	            	onClick={okBtnClicked}
	            >
	            	OK
	           	</button>				
			);
		buttons.push(
            <button
            	key="cancel-btn"
            	className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            	onClick={cancelCallback}
            >
            		Cancel
            </button>				
		);
		return buttons;
	};

	return (
		<WindowDialog
			contentLayout="grid"
			title={"Select " + label} 
			onClose={cancelCallback}
			initialHeight={heightMatches ? 600 : 400}
			minHeight={300}
			initialWidth={widthMatches ? 600 : 400}
			minWidth={300}
			render={getSelectionView}
			buttons={getButtons()}
		/>
	);
}